import { render, staticRenderFns } from "./bannerManagement.vue?vue&type=template&id=797158ca"
import script from "./bannerManagement.vue?vue&type=script&lang=js"
export * from "./bannerManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports